module.exports = __webpack_public_path__ + "static/media/emojis2_20.ef3253d8.svg";